import React, {Component} from "react";
import logger from "./Logger"
import AuthService from "../service/AuthService";

export class AuthBox extends Component {
    static containerId = 'auth0-container';

    componentDidMount() {
        switch (this.props.mode) {
            case 'login':
                AuthService.login(AuthBox.containerId);
                break;

            case 'register':
                AuthService.register(AuthBox.containerId);
                break;

            case 'forgot':
                AuthService.forgotPassword(AuthBox.containerId);
                break;

            default:
                logger.error(`Unsupported mode: ${this.props.mode}`)
        }
    }

    render() {
        /* z-index set to avoid auth0 container overlaying nav bar */
        return (
            <div className={this.props.className} style={{zIndex: 100}} id={AuthBox.containerId}/>
        )
    }
}

AuthBox.propTypes = {
    mode: React.PropTypes.string
};

export default AuthBox;



// WEBPACK FOOTER //
// ./src/modules/common/AuthBox.js